import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter } from '../../global/commonStyle';

interface NavigationActiveIndicatorProps {
  highlighterWidth?: number;
  highlighterLeft?: number;
}

const NavigationWrapper = styled.div`
  display: none;
  ${mobile_xl(css`
    padding: var(--space-20) var(--space-24);
    ${AlignCenter}
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: var(--z-index-header);
    width: calc(100vw - 40px);
    isolation: isolate;
    overflow: hidden;
    background: transparent;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: var(--background-glass-effect);
      backdrop-filter: blur(8px);
      -webkit-mask-image: var(--progressive-blur);
      mask-image: var(--progressive-blur);
      pointer-events: none;
    }

    .left-gradient {
      background: var(--left-gradient);
      position: absolute;
      bottom: 0;
      left: 24px;
      height: 48px;
      width: 100vw;
    }
    & > * {
      position: relative;
      z-index: var(--z-index-base);
    }
  `)}
`;

const NavigationItemWrapper = styled.div`
  ${FlexBetween}
  width: 100%;
  border-radius: var(--border-radius-full);
  overflow: hidden;
  padding: var(--space-4);
  position: relative;
  background: var(--glass-base-tint);
  box-shadow: var(--glass-drop-shadow);
  backdrop-filter: blur(14px);
`;

const NavigationItem = styled.div`
  width: 100%;
  max-width: 75px;
  ${FlexCenter}
  border-radius: var(--border-radius-full);
  z-index: var(--z-index-base);
  height: 48px;
  svg path {
    fill: var(--text-primary);
  }
`;

const NavigationActiveIndicator = styled.div<NavigationActiveIndicatorProps>`
  position: absolute;
  top: 4px;
  left: 0;
  height: 48px;
  border-radius: var(--border-radius-full);
  background: var(--glass-active-background);
  backdrop-filter: blur(14px);
  transition: transform var(--transition-normal) ease, width var(--transition-normal) ease;
  z-index: var(--z-index-0);
  width: ${({ highlighterWidth }) => `${highlighterWidth}px`};
  transform: ${({ highlighterLeft }) => `translateX(${highlighterLeft}px)`};
`;

export { NavigationWrapper, NavigationItem, NavigationItemWrapper, NavigationActiveIndicator };
